import { useNavigate } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Calendar } from 'lucide-react';

export default function TaskerEarnings() {
  const navigate = useNavigate();

  const monthlyEarnings = [
    { month: 'Dec', amount: 4200, jobs: 15 },
    { month: 'Nov', amount: 3850, jobs: 14 },
    { month: 'Oct', amount: 4100, jobs: 16 },
    { month: 'Sep', amount: 3600, jobs: 12 },
  ];

  const recentTransactions = [
    { id: '1', date: '2024-12-24', service: 'Pipe Repair', amount: 140, status: 'completed' },
    { id: '2', date: '2024-12-23', service: 'Drain Cleaning', amount: 170, status: 'completed' },
    { id: '3', date: '2024-12-22', service: 'Emergency Repair', amount: 235, status: 'completed' },
    { id: '4', date: '2024-12-21', service: 'Installation', amount: 190, status: 'completed' },
    { id: '5', date: '2024-12-20', service: 'Leak Detection', amount: 160, status: 'pending' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft size={24} />
          </button>
          <h2 className="text-[#1E3A8A]">Earnings</h2>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Total Earnings */}
        <div className="bg-linear-to-r from-[#006C35] to-[#005428] rounded-2xl p-6 text-white mb-6">
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp size={24} />
            <span className="opacity-90">Total Earnings</span>
          </div>
          <div className="text-4xl mb-1">15,750 SAR</div>
          <p className="text-sm opacity-90">Lifetime earnings from 57 jobs</p>
        </div>

        {/* Monthly Breakdown */}
        <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
          <h3 className="text-[#1E3A8A] mb-4">Monthly Breakdown</h3>
          <div className="space-y-4">
            {monthlyEarnings.map((month) => (
              <div key={month.month} className="flex items-center gap-4">
                <div className="w-16 text-center">
                  <Calendar size={20} className="text-[#006C35] mx-auto mb-1" />
                  <span className="text-sm text-gray-600">{month.month}</span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-[#1E3A8A]">{month.amount} SAR</span>
                    <span className="text-sm text-gray-600">{month.jobs} jobs</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-[#006C35] h-2 rounded-full transition-all"
                      style={{ width: `${(month.amount / 5000) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Transactions */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-[#1E3A8A] mb-4">Recent Transactions</h3>
          <div className="space-y-3">
            {recentTransactions.map((transaction) => (
              <div 
                key={transaction.id}
                className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
              >
                <div>
                  <h4 className="text-[#1E3A8A] mb-1">{transaction.service}</h4>
                  <p className="text-sm text-gray-600">
                    {new Date(transaction.date).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </p>
                </div>
                <div className="text-right">
                  <div className="text-[#006C35] mb-1">{transaction.amount} SAR</div>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    transaction.status === 'completed'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {transaction.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Withdrawal */}
        <div className="mt-6 bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-[#1E3A8A] mb-4">Available Balance</h3>
          <div className="flex items-center justify-between">
            <div>
              <div className="text-3xl text-[#006C35] mb-1">4,200 SAR</div>
              <p className="text-sm text-gray-600">Current month earnings</p>
            </div>
            <button className="px-6 py-3 bg-[#006C35] text-white rounded-lg hover:bg-[#005428] transition-colors">
              Withdraw
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
